import type { EmployeeHeadcount } from "app/pages/sales-intelligence/domain/leads/types/enums";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

export default class FindEmployeeHeadcountFilter extends FilterPanelBaseFilter<
    readonly EmployeeHeadcount[],
    readonly EmployeeHeadcount[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly EmployeeHeadcount[], readonly EmployeeHeadcount[]>) {
        super(deps);
    }

    calculateValueDelta = (
        previousValue: readonly EmployeeHeadcount[] | undefined,
        newValue: readonly EmployeeHeadcount[] | undefined,
    ): FilterValueDelta<EmployeeHeadcount> => {
        return calculateArrayDelta(previousValue, newValue);
    };
}
